import { Box } from "@mantine/core";

interface Props {
  /**
   * Any Spotify URL form:
   *   - https://open.spotify.com/track/<id>
   *   - https://open.spotify.com/album/<id>
   *   - https://open.spotify.com/embed/track/<id>
   * Embed form is used as-is; non-embed URLs are rewritten to embed form.
   */
  url: string;
  /** Compact (152) or full (352). Default compact — good for inline listening. */
  variant?: "compact" | "full";
  title?: string;
}

function toEmbedUrl(input: string): string {
  if (input.includes("/embed/")) return input;
  return input
    .replace("/track/", "/embed/track/")
    .replace("/album/", "/embed/album/")
    .replace("/playlist/", "/embed/playlist/")
    .replace("/episode/", "/embed/episode/")
    .replace("/show/", "/embed/show/");
}

export function SpotifyEmbed({ url, variant = "compact", title = "Spotify embed" }: Props) {
  const embedUrl = toEmbedUrl(url);
  const height = variant === "full" ? 352 : 152;

  return (
    <Box style={{ borderRadius: 12, overflow: "hidden" }}>
      <iframe
        src={embedUrl}
        width="100%"
        height={height}
        style={{ border: 0, display: "block" }}
        loading="lazy"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        title={title}
      />
    </Box>
  );
}
